import * as BaseApi from "api/Base.api";
import { IPagination } from "api/interfaces/common.interface";
import { IDiary } from "api/interfaces/profile.interface";

//* 홈 정보 조회    
//  2025.03.04
//  희문
//* Params
//  none
export const getInfoForHome = async () => {
    const url = "/agency/v2/home";
    return await BaseApi.get(url);
};

//* 홈 지망생 사진첩 조회
//  2025.04.09
//  희문
//* Params
//  date: string
export const getStudentPhotos = async (date: string) => {
    const url = "/agency/v2/home/student-photos";
    return await BaseApi.get(url, { date });
};

export interface IStudentDiariesResult {
    diaryList: IDiary[];
    pagination: IPagination;
}

//* 홈 지망생 다이어리 목록 조회
//  2025.08.26
//  희문
//* Params
//  page: number
export const getStudentDiaries = async (page: number): Promise<IStudentDiariesResult> => {
    try {
        const url = "/agency/v2/home/student-diaries";
        const data = await BaseApi.get(url, { page });
        console.log("🔍 getStudentDiaries API 응답:", { page, data });
        return data as IStudentDiariesResult;
    } catch (error) {
        console.error("❌ getStudentDiaries API 실패:", error);
        throw error;
    }
};